import { render } from "./VF-dropdown-item.vue?vue&type=template&id=789e68e9"
import script from "./VF-dropdown-item.vue?vue&type=script&lang=js"
export * from "./VF-dropdown-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__